export const PAYGENT_DDD_ERROR_RESULT = 1;
export const AUTHENTICATION_TIMEOUT_ERROR_RESPONSE_CODE = "31013";

export type PaygentDDDSecureQuery = Readonly<{
  type: string;
  ddd_result: number;
  ddd_auth_id: string;
  attempt_kbn?: number;
  hash: string;
  user_delivery_address_id: string;
  deluxe_request: string;
  ddd_response_code: string;
  ddd_response_detail: string;
  ddd_requestor_error_code: string;
  ddd_server_error_code: string;
}>;

const create = (
  args: Partial<PaygentDDDSecureQuery> = {}
): PaygentDDDSecureQuery => ({
  type: "",
  ddd_result: PAYGENT_DDD_ERROR_RESULT,
  ddd_auth_id: "",
  attempt_kbn: undefined,
  hash: "",
  user_delivery_address_id: "",
  deluxe_request: "",
  ddd_response_code: "",
  ddd_response_detail: "",
  ddd_requestor_error_code: "",
  ddd_server_error_code: "",
  ...args,
});

export const PaygentDDDSecureQuery = { create } as const;
